export default "__VITE_ASSET__58af26b6__"